module.exports = __webpack_public_path__ + "img/logo_nav.b76c6195.png";